import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { chatDashboardSettingsPatchRest } from 'app/rest/effects/chatDashboardSettings/api/helpers/chatDashboardSettingsPatchRest';
import { IChatDashboardSettings } from 'app/store/model/chatDashboardSettings/types';

export const chatDashboardSettingsSet = (
    boardId: TBoardId,
    chatDashboardSettings: IChatDashboardSettings,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(chatDashboardSettingsPatchRest(boardId, chatDashboardSettings));
    };
    return action;
}
